import { unmountComponentAtNode, render } from 'react-dom';

export default class ServiceManager {
  constructor(queue, tag = 'span') {
    this.queue = queue;
    this.tag = tag;
  }

  handleClose = (key) => {
    this.queue.delete(key);
  }

  close(key) {
    this.handleClose(key);
  }

  destroy() {
    this.queue.deleteAll();
    if (this.el) {
      unmountComponentAtNode(this.el);
      document.body.removeChild(this.el);
      this.el = null;
    }
  }

  get mountNode() {
    if (this.el) {
      return this.el;
    }
    const node = this.createMountNode(this.tag);
    this.el = node;
    return node;
  }

  createSlice(key, duration) {
    let timeoutKey;
    const startTimeout = () => {
      if (typeof duration === 'number' && duration !== 0) {
        timeoutKey = window.setTimeout(() => {
          this.handleClose(key);
        }, duration);
      }
    };
    const clearTimeout = () => {
      if (timeoutKey) {
        window.clearTimeout(timeoutKey);
      }
    };
    startTimeout();
    return { clearTimeout, startTimeout };
  }

  createMountNode(tag) {
    const el = document.createElement(tag);
    document.body.appendChild(el);
    return el;
  }

  flush(component, callback) {
    render(component, this.mountNode, callback);
  }
}
